import { ValueLabelElement } from '@ps20-frontend/frontend-models';

export const initialeHunderassenAuswahlElemente: Array<ValueLabelElement> = [];
